import { render, staticRenderFns } from "./PlayAndWinHome.vue?vue&type=template&id=589db13c&scoped=true&"
import script from "./PlayAndWinHome.vue?vue&type=script&lang=js&"
export * from "./PlayAndWinHome.vue?vue&type=script&lang=js&"
import style0 from "./PlayAndWinHome.vue?vue&type=style&index=0&id=589db13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589db13c",
  null
  
)

export default component.exports